/* Linked-listings SWAP engine (v2, 2026-09-04).

   A mapped card carries a family registry (JSON payload per sibling — see
   snippets/nesw-pack-swap-chips.liquid) and chip rows whose buttons name a
   data-ll-target handle. Clicking a chip swaps the CARD in place — image,
   price, title, links, cotton/sale badges, quick-add dataset — and rebuilds
   the chip rows from the target's OWN map (the heavy hoodie's groups point
   at different products than the light's). Never navigates; the quick-add
   sheets proxy these chips into the popup (hidden groups included), which
   is how Lightweight/Heavyweight and Single/3-Pack switch inside the sheet.

   Capture phase + stopPropagation: chips sit inside the card's <a> on home
   rows, and the legacy variant pack-btn handler matches .pack-btn broadly. */
(function () {
  if (window.__neswPackSwapWired) return;
  window.__neswPackSwapWired = true;

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function registryOf(card) {
    var el = card.querySelector('script[data-ll-registry]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  /* Rebuild the chip rows from a payload's own map string. Mirrors the
     Liquid render in nesw-pack-swap-chips.liquid: all-pack groups visible,
     others hidden (the sheets surface them). */
  function buildRows(map, selfHandle) {
    if (!map) return '';
    return map.split('|').map(function (g) {
      var gp = g.split('>');
      var pills = (gp[1] || '').split(',');
      var allPack = pills.every(function (p) { return p.split('*')[0].indexOf('-Pack') !== -1; });
      var btns = pills.map(function (p) {
        var pp = p.split('*');
        var target = (pp[1] || '').trim();
        return '<button type="button" class="pack-btn' + (target === selfHandle ? ' active' : '') + '" data-ll-target="' + esc(target) + '">' + esc(pp[0]) + '</button>';
      }).join('');
      return '<div class="nesw-row__packs nesw-row__packs--ll" aria-label="' + esc(gp[0]) + '"' + (allPack ? '' : ' data-ll-hidden="1" style="display:none;"') + '>' + btns + '</div>';
    }).join('');
  }

  /* Apply a payload to a card. Exposed so the sheets could reuse it, and so
     everything that swaps stays in one place. */
  function applySwap(card, data) {
    /* Images: primary + hover flip. Direct src wins over srcset/lazyload. */
    var img1 = card.querySelector('img.product-image:not(.product-image--hover)');
    if (img1 && data.img) {
      img1.src = data.img;
      img1.removeAttribute('srcset');
      img1.removeAttribute('data-srcset');
      img1.alt = data.title || '';
    }
    var img2 = card.querySelector('img.product-image--hover');
    if (img2) {
      var h = data.img2 || data.img;
      if (h) { img2.src = h; img2.removeAttribute('srcset'); img2.removeAttribute('data-srcset'); }
    }

    /* Title + price. Surfaces order price/compare differently: home rows put
       the struck compare FIRST, collection cards render price first. */
    var titleEl = card.querySelector('.nesw-row__name, .prouduct-title');
    if (titleEl) titleEl.textContent = data.title || '';
    var priceEl = card.querySelector('.nesw-row__price, .collection-product-price');
    if (priceEl && data.price) {
      var compareFirst = priceEl.classList.contains('nesw-row__price');
      while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
      var priceNode = document.createTextNode(data.price);
      if (data.compare) {
        var del = document.createElement('del');
        del.textContent = data.compare;
        if (compareFirst) {
          priceEl.appendChild(del);
          priceEl.appendChild(document.createTextNode(' '));
          priceEl.appendChild(priceNode);
        } else {
          priceEl.appendChild(priceNode);
          priceEl.appendChild(document.createTextNode(' '));
          priceEl.appendChild(del);
        }
      } else {
        priceEl.appendChild(priceNode);
      }
    }

    /* Badges follow the shown product: cotton eligibility and sale state
       differ across a family (light hoodie: no cotton badge; heavy: badge).
       Server-rendered HTML from the payload, so the gates stay in Liquid. */
    var cottonWrap = card.querySelector('.nesw-row__cotton');
    if (cottonWrap && typeof data.cottonHtml === 'string') cottonWrap.innerHTML = data.cottonHtml;
    var saleWrap = card.querySelector('.nesw-card-salebadge');
    if (saleWrap && typeof data.saleHtml === 'string') saleWrap.innerHTML = data.saleHtml;

    /* Card links -> the shown product's PDP */
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.setAttribute('href', data.url);
    });

    /* Quick-add dataset: the sheet must sell the shown product. Adds go by
       variant id, which is valid across products. */
    var qab = card.querySelector('.quick-add-btn');
    if (qab) {
      qab.dataset.productId = String(data.id || '');
      qab.dataset.productTitle = data.title || '';
      qab.dataset.productPrice = data.price || '';
      qab.removeAttribute('data-product-price-html');
      qab.dataset.variants = JSON.stringify(data.variants || []);
      qab.dataset.firstVariantId = String(data.firstVariantId || '');
      qab.dataset.hasSizes = data.hasSizes ? 'true' : 'false';
      qab.dataset.productHandle = data.handle || '';
      qab.dataset.productUrl = data.url;
      qab.dataset.productImage = data.img || '';
    }
    var wrap = card.querySelector('.quick-add-wrapper');
    if (wrap) {
      wrap.dataset.productId = String(data.id || '');
      delete wrap.dataset.selectedColor;
      delete wrap.dataset.selectedColorImage;
      delete wrap.dataset.selectedExtra;
    }

    /* Rebuild the chip rows for the shown product's own map. */
    var rows = card.querySelector('.nesw-ll-rows');
    if (rows) rows.innerHTML = buildRows(data.map || '', data.handle);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('.pack-btn[data-ll-target]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('.collection-item, .nesw-row__card-wrap');
    if (!card) return;
    var reg = registryOf(card);
    var data = reg && reg[b.getAttribute('data-ll-target')];
    if (!data || !data.url) return;
    applySwap(card, data);
  }, true);

  window.__neswApplyLLSwap = applySwap;
})();
